import TransferListPage from './TransferListPage';

export default TransferListPage;
